import React from 'react';
import styled from 'styled-components';
import {keyframes} from 'styled-components';
import { useSelector } from 'react-redux';
import {selectSpinner, selectSpinnerType} from './spinnerSlice';
import {fontSize} from '../../mixins';

const spinning = keyframes`
    to {
        transform: rotate(360deg);
       }
`

const StyledSpinnerWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #ffffffd6;
  border-radius: 4px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  
      
    p {
      ${fontSize(16)};
      line-height: 18px;
      text-align: center;
      letter-spacing: -0.138667px;
      color: #323232;
      margin-top: 32px;

      @media screen and (min-width: 768px) {
        ${fontSize(24)};
        line-height: 36px;
      }
  }
`



const StyledSpinner = styled.div`
    height: 100px;
    width: 100px;
    border-radius: 50%;
    background-color: transparent;
    border: 3px solid #23CBA7;
    border-right-color: transparent;
    animation: ${spinning} 2s linear infinite;
`

const Spinner = (props) => {
    const show = useSelector(selectSpinner);
    const spinnerType = useSelector(selectSpinnerType);

    const spinnerText = spinnerType === 'checkout'
        ? 'Please keep the page open. Your order is being processed. Billing may take a few minutes.'
        : '';


    if (props.suspenseShow || show) {
        return(
            <StyledSpinnerWrapper>
                <StyledSpinner></StyledSpinner>
                <p>{spinnerText}</p>
            </StyledSpinnerWrapper>
        );

    }

    return null;
};

export default Spinner;